/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Lexique_Verify_GatewayInputs */



/**
* | output |
* | --- |
* | "Check gateway status" |
*
* @param {Intervention_Plan_Pdf_Lexique_Verify_GatewayInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_lexique_verify_gateway = /** @type {((inputs?: Intervention_Plan_Pdf_Lexique_Verify_GatewayInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Lexique_Verify_GatewayInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Check gateway status")
	return /** @type {LocalizedString} */ ("Vérifier état de la box")
});